<template>
  <ContentSection
    spacing="none"
    :class="conditionalSpacing"
  >
    <Container indent="lg-but-on-mobile-default">
      <div class="max-w-container-text">
        <!-- TITLE -->
        <h2
          v-if="data.heading"
          v-animate-in-from-bottom
          class="mb-3 typo-heading-md sm:mb-4 sm:typo-heading-lg"
          v-html="data.heading"
        />

        <!-- ACCORDION -->
        <ul v-animate-children-in-from-left class="space-y-3 sm:space-y-4">
          <li
            v-for="(element, index) in data.accordion_elements"
            :key="element.id"
          >
            <AccordionElement

              :duration-open="300"
              :set-open="index === openAccordionIndex"
              @open="openAccordionIndex = index"
              @close="
                index === openAccordionIndex ? (openAccordionIndex = null) : null
              "
            >
              <!-- Title -->
              <template #summary>
                <h3 class="">
                  {{ element.title }}
                </h3>
              </template>

              <!-- Content -->
              <template #content>
                <div
                  class="wysiwyg"
                  v-html="element.text"
                />
              </template>
            </AccordionElement>
          </li>
        </ul>
      </div>
    </Container>
  </ContentSection>
</template>

<script setup lang="ts">
import type { ComponentsMainAccordionFragment } from '#gql'

const props = defineProps<{
  data: Enforce<ComponentsMainAccordionFragment>
  prevComponent?: string | null
  nextComponent?: string | null
}>()

const openAccordionIndex = ref<number | null>(null)

const conditionalSpacing = useConditionalSpacing(
  props.prevComponent,
  props.nextComponent,
)
</script>
